import EmployeeModelBase from '../_generated/modelBases/employee-model-base';

export default class EmployeeModel extends EmployeeModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
